<template>
  <div>
    <a-form :form="newLinkmanForm" class="addForm">
      <a-row>
        <a-col :span="5">
          <div class="labelText">{{$t('track.trackModal.contactNameLabel')}}<span style="font-size:14px;color:#f5222d;">*</span></div>
        </a-col>
        <a-col :span="5" :offset="1">
          <div class="labelText">{{$t('track.trackModal.positionLabel')}}</div>
        </a-col>
        <a-col :span="5" :offset="1">
          <div class="labelText">{{$t('track.trackModal.contactNum')}}</div>
        </a-col>
        <a-col :span="5" :offset="1">
          <div class="labelText">{{$t('track.trackModal.contactEmail')}}</div>
        </a-col>
      </a-row>
      <a-row v-for="(item,index) in contactList" :key="index">
        <a-col :span="5">
          <a-form-item>
            <pt-input  v-decorator="[`linkmanDOList[${index}].name`,{rules: [
                {required: true,message: $t('customer.customerModal.contactNameTip'),},
              ],}]" :placeholder="$t('track.trackModal.contactNameTip')"></pt-input>
          </a-form-item>
        </a-col>
        <a-col :span="5" :offset="1">
          <a-form-item>
            <a-input  v-decorator="[`linkmanDOList[${index}].job`,{rules: [
               {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.positionTip')"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="5" :offset="1">
          <a-form-item>
            <a-input  v-decorator="[`linkmanDOList[${index}].phone`,{rules: [
                {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.contactNum')"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="5" :offset="1">
          <a-form-item>
            <a-input  v-decorator="[`linkmanDOList[${index}].email`,{rules: [
                {
                  type: 'email',
                  message:$t('customer.customerModal.emailErrorTip'),
                },
                {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.contactEmail')">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="1">
          <div class="deleteBtn" @click="delContactRow(index)" v-if="index !== 0">
            <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <div class="addBtn" @click="addContactRow">
          <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
        </div>
      </a-row>
    </a-form>
  </div>
</template>

<script>
  import Api from '@/api/database/linkman'
  import { insertBatch } from '../../api/database/linkman'
  export default {
    name: 'newLinkman',
    props:{
      modeType:{
        type:String,
        default:1,
      },
      customerId:{
        type:String,
        required: true
      }
    },
    data(){
      return{
        contactList:[1,2],
        newLinkmanForm:this.$form.createForm(this,{}),
        linkmanListVO:{
          linkmanList:[]
        },
      }
    },
    methods:{
      delContactRow(index){
        let keys = this.newLinkmanForm.getFieldValue("linkmanDOList");
        this.newLinkmanForm.setFieldsValue({
          linkmanDOList: keys.filter((item,i) => index !== i)
        })
        this.contactList.splice(index,1);
      },
      addContactRow(){
        this.contactList.push(1);
      },
      submitData(){
        this.newLinkmanForm.validateFieldsAndScroll((err,value) => {
          if(!err){
            console.log(value)
            this.buildSaveData(value)
          }else{
            this.$emit("error")
          }
        })
      },
      buildSaveData(value){
        let linkmanList = value.linkmanDOList
        linkmanList.forEach(data=>{
          data.businessId = this.customerId;
          data.type = this.modeType;
        })
        console.log(linkmanList)
        this.saveLinkmans(linkmanList);
      },
      saveLinkmans(linkmanList){
        Api.insertBatch(linkmanList).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.$bus.$emit('flushCustomerDetail')
            this.$emit('saveSuccess');
          }else{
            this.$emit("error")
          }
        }).catch(()=>{
          this.$emit("error")
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .addForm{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 35px 20px;
    .deleteBtn{
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
      .delIcon{
        font-size: 18px;
      }
    }
    .labelText{
      font-size: 12px;
      color: #999999;
      margin-left: 4px;
    }
    .addBtn{
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-bottom: 18px;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
  }
</style>